import { addErrorNotice, callApi, camelizeObjectKeys, catchWithAuthErrors } from 'Data/Helpers/rxjsHelpers';
import { actions as noticeActions } from 'Data/ReduxViewModels/Notices';
import webApi from 'Lib/WebApi';
import { Epic, ofType } from 'redux-observable';
import { of } from 'rxjs';
import { ignoreElements, mergeMap, tap } from 'rxjs/operators';
import { actions } from './slice';
import { IInterLabWorkOrderModel } from './types';

export const getWorkOrder: Epic = (action$) =>
  action$.pipe(
    ofType(actions.getWorkOrder.toString()),
    mergeMap(({ payload: workOrderId }) =>
      callApi(webApi.interlab.workorder.get({ workOrderId })).pipe(
        mergeMap(({ Body }) =>
          of(
            actions.getWorkOrderResolve({
              ...(camelizeObjectKeys(Body) as IInterLabWorkOrderModel),
              samples: Body.Samples.map(camelizeObjectKeys),
            })
          )
        ),
        catchWithAuthErrors((err: any) => of(addErrorNotice(`Failed to retrieve work order.`, err)))
      )
    )
  );

export const transfer: Epic = (action$) =>
  action$.pipe(
    ofType(actions.transfer.toString()),
    mergeMap(({ payload: { workOrderId, laboratoryId, transferNote } }) =>
      callApi(
        webApi.interlab.workorder.transfer.post({ Body: { TransferNote: transferNote } }, { workOrderId, laboratoryId })
      ).pipe(
        mergeMap(({ Body }) =>
          of(
            actions.transferResolve({
              ...(camelizeObjectKeys(Body) as IInterLabWorkOrderModel),
              samples: Body.Samples.map(camelizeObjectKeys),
            })
          )
        ),
        catchWithAuthErrors((err: any) =>
          of(addErrorNotice(`Failed to transfer work order.`, err), actions.transferReject())
        )
      )
    )
  );

export const notifyTransfer: Epic = (action$) =>
  action$.pipe(
    ofType(actions.transferResolve.toString()),    
      tap(({payload: {id}}) => { 
        document.body.dispatchEvent(new CustomEvent("workOrderTransferred", {detail: id}))
      }),
      ignoreElements()
  );

export const copy: Epic = (action$) =>
  action$.pipe(
    ofType(actions.copy.toString()),
    mergeMap(({ payload: { workOrderId, sampleIds } }) =>
      callApi(webApi.interlab.workorder.copy.post({ Body: { SampleIds: sampleIds } }, { workOrderId })).pipe(
        mergeMap(({ Body }) => {
          const body = {
            ...(camelizeObjectKeys(Body) as IInterLabWorkOrderModel),
            samples: Body.Samples.map((x: any) => camelizeObjectKeys(x)),
          };

          return of(addSuccessCopyNotice(body), actions.copyResolve(body));
        }),
        catchWithAuthErrors((err: any) => of(addErrorNotice(`Failed to copy work order.`, err), actions.copyReject()))
      )
    )
  );

export const getActionHistory: Epic = (action$) =>
  action$.pipe(
    ofType(actions.getActionHistory.toString()),
    mergeMap(({ payload: workOrderId }) =>
      callApi(webApi.interlab.workorder.history.get({ workOrderId })).pipe(
        mergeMap(({ Body: { ActionHistories } }) =>
          of(actions.getActionHistoryResolve(ActionHistories.map(camelizeObjectKeys)))
        ),
        catchWithAuthErrors((err: any) => of(addErrorNotice(`Failed fetch work order action history.`, err)))
      )
    )
  );

const addSuccessCopyNotice = ({ copyId, copyWorkOrderId }: IInterLabWorkOrderModel) => {
  return noticeActions.addNotice({
    message: `Work order and selected samples successfully copied to ${copyWorkOrderId}.`,
    severity: 'success',
    link: {
      linkText: `Open Transfer Setup for ${copyWorkOrderId} to transfer it`,
      url: `/inter-lab/${copyId}`,
    },
  });
};
